import React, { memo, type MouseEvent, type KeyboardEvent } from 'react';
import { DropdownItem } from '@atlaskit/dropdown-menu';
import type { ProjectPage } from '@atlassian/jira-forge-ui-types/src/common/types/extension.tsx';
import { parseExtensionId } from '@atlassian/jira-forge-ui-utils-internal/src/utils/parse-extension-id/index.tsx';
import AppItemIcon from '@atlassian/jira-horizontal-nav-icons/src/ui/app-item-icon/index.tsx';
import type { NavigationProject } from '@atlassian/jira-router-resources-business-navigation/src/types.tsx';
import { Link } from '@atlassian/react-resource-router';

type Props = {
	data: ProjectPage;
	project: NavigationProject;
	onItemClick: (e: MouseEvent<Element> | KeyboardEvent<Element>) => void;
};

const getForgeItemLink = (forgeItem: ProjectPage, projectKey: string) => {
	const { appId, envId } = parseExtensionId(forgeItem.id);
	return `/jira/core/projects/${projectKey}/apps/${appId}/${envId}`;
};

const ForgeItem = ({ data, project, onItemClick }: Props) => (
	<DropdownItem
		// @ts-expect-error - dropdown item is poorly typed and won't allow Link to be used even though it is compatible
		component={Link}
		elemBefore={<AppItemIcon url={data.properties.icon} />}
		onClick={onItemClick}
		href={getForgeItemLink(data, project.key)}
		UNSAFE_shouldDisableRouterLink
	>
		{data.properties.title}
	</DropdownItem>
);

export default memo<Props>(ForgeItem);
